import store from '../store/index'
import router from '../router/index'
import Cookies from "js-cookie";
import {MessageBox, Message} from 'element-ui'

const axios = require('axios')

// 如果请求花费了超过 `timeout` 的时间，请求将被中断
axios.defaults.timeout = 300000

// `responseType` 表示服务器响应的数据类型，
//  可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
axios.defaults.responseType = 'json'

// 允许请求时携带cookie
axios.defaults.withCredentials = false

axios.defaults.baseURL =  process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_API_BASE_URL
      : process.env.VUE_APP_API_BASE_URL + location.host.substring(location.host.indexOf('.')),

// `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。
// 如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve;
// 否则，promise 将被 rejecte
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status < 300 // 默认的
}

// 请求拦截 可设置请求头公共信息
axios.interceptors.request.use(
  config => {
    if (Cookies.get("jwt_token_valid") && localStorage.getItem("jwtToken")) {
      config.headers["Authorization"] = localStorage.getItem("jwtToken");
    } else {
      store.dispatch("loginOut").then(() => {
        if (location.href.indexOf("login") === -1) {
          router.push("/login");
        }
        return;
      });
    }
    // config.headers["Authorization"] = "Bearer eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJudWxsLDQiLCJuZXdfcm9sZSI6IntcImVvcy1zeXN0ZW1cIjpbXCI0XCJdfSIsInR5cGUiOjMsImV4cCI6MTY5ODM3MTAyNSwiaWF0IjoxNjk4Mjg1MDI1LCJqdGkiOiJwZ3c0NDk5Iiwic3RhdHVzIjoxfQ.WCneLtEYDw70z4sSb7eXpnaEwBQ6ABS6bY_Q0gL7GPYi4DTbPtrLvw3rvkWlowidg-QCXBnOXLmCXBWVr_Z3pQ"
    config.headers['clientId'] = store.state.request.appId
    return config
  },
  err => {
    console.error(err)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 0) {
      return Promise.resolve(response)
    } else {
      console.log(response.config.url)
      if (response.data.msg && response.data.msg.indexOf("JWT Token expired") > -1) {
        store.dispatch("loginOut").then(() => {
          router.push("/login");
        });
      } else  {
        // 这里做错误提示，如果使用了 element ui 则可以使用 Message 进行提示
        Message({
                    message: response.data.msg || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
        return Promise.reject(response.data)
      }
    }
  },
  error => {
    return Promise.reject(error.response.data)
  })

function http(options, success, fail) {
    axios(options).then(function (response) {
        success(response.data)
    })
    .catch(function (error) {
        fail({
            msg: error
        }, '未收到返回数据')
    })
}

function get(options, success, fail) {
    var requestOption = Object.assign({
        method: 'get',
        params: options.data
    }, options)
    http(requestOption, success, fail)
}


function post(options, success, fail) {
    var requestOption = Object.assign({
        method: 'post'
    }, options)
    http(requestOption, success, fail)
}

function put(options, success, fail) {
    var requestOption = Object.assign({
        method: 'put'
    }, options)
    http(requestOption, success, fail)
}

function delete1(options, success, fail) {
    var requestOption = Object.assign({
        method: 'delete'
    }, options)
    http(requestOption, success, fail)
}

function deleteParam(options, success, fail) {
    var requestOption = Object.assign({
        method: 'delete',
        params: options.data
    }, options)
    http(requestOption, success, fail)
}

function isIE9() {
    if (
        navigator.appName === 'Microsoft Internet Explorer' &&
        parseInt(
            navigator.appVersion
                .split(';')[1]
                .replace(/[ ]/g, '')
                .replace('MSIE', '')
        ) <= 9
    ) {
        return true
    }
    return false
}

export {
    get,
    post,
    put,
    delete1,
    deleteParam,
}

export {
    axios
}
